<template>
<um-page class="page-course-home">
  <div class="course-home-container">
    <HomeHeader></HomeHeader>
    <div class="home-body">
      <div class="cover-wrapper" :style="{'background-image': 'url('+ buildResourcePath(course.cover) +')'}">
        <div class="video-wrapper" v-if="course.briefdesc">
          <video :id="'video-media'" width="100%" height="100%" :poster="course.cover | fullpath" playsinline webkit-playsinline class="custom-video">
            <source type="video/mp4" :src="course.briefdesc | fullpath"  />
          </video>
        </div>
      </div>
      <div class="course-info">
        <div class="title">{{course.name}}</div>
        <div class="info">
          <div class="school">{{course.openCourseSchool}}</div>
          <div class="join-num">{{course.studentCount || 0}}人参与</div>
        </div>
        <van-dropdown-menu v-if="course.isCharge && course.terms && course.terms.length > 0">
          <van-dropdown-item v-model="currentTermId" :options="course.terms" @change="dropdownChange" />
        </van-dropdown-menu>
      </div>
      <div class="tabs-wrapper">
        <div class="tabs">
          <div class="tab-item">
            <div class="tab" :class="{'is-active': tabIndex === 0}" @click="tabChange(0)">课程详情</div>
          </div>
          <div class="tab-item">
            <div class="tab" :class="{'is-active': tabIndex === 1}" @click="tabChange(1)">章节目录</div>
          </div>
        </div>
      </div>
      <div class="tab-content tab-detail" v-show="tabIndex === 0">
        <div class="course-section">
          <div class="section-title">课程简介</div>
          <richtext :content="termTextbook.description" :overflowHeight="120"></richtext>
        </div>
        <div class="course-section">
          <div class="section-title">
            <span>课程团队</span>
            <div class="detail-entry" @click="toMember">详情<i class="iconfont icon-youye"></i></div>
          </div>
          <ul class="member-list">
            <li v-for="item in termTextbook.textbookTeacherList" :key="item.id">
              <img :src="item.headimage | avatar" alt="">
              <div class="name">{{item.name}}</div>
              <div class="school">{{item.orgname}}</div>
            </li>
          </ul>
        </div>
        <div class="course-section"  v-if="termTextbook.teachingOutline">
          <div class="section-title">教学大纲</div>
          <richtext :content="termTextbook.teachingOutline" :overflowHeight="120"></richtext>
        </div>
        <div class="course-section" v-if="termTextbook.bookName">
          <div class="section-title">推荐教材</div>
          <div class="textbook-wrapper">
            <img :src="termTextbook.bookCover" alt="" class="cover">
            <div class="textbook-info">
              <div class="title">{{termTextbook.bookName}}</div>
              <div class="info-item">作者：<span v-for="item in termTextbook.authorList" :key="item.coursebookUserId">{{item.userName}}</span></div>
              <div class="info-item">出版社：{{termTextbook.publishingHouse}}</div>
              <div class="info-item">ISBN：{{termTextbook.isbn}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content tab-index"  v-show="tabIndex === 1">
        <ul class="chapter-list">
          <li v-for="chapter in termTextbook.chapterList" :key="chapter.id">
            <div class="chapter-item">
              <div class="chapter-title">{{chapter.name}}</div>
              <span class="audition" v-if="chapter.audition" @click="preview(chapter.id)">去体验<i class="iconfont icon-gengduo"></i></span>
            </div>
            <ul class="node-list">
              <li v-for="node in chapter.itemList" :key="node.id">
                <div class="dot"></div>
                <div class="node-title">{{node.name}}</div>
                <span class="audition" v-if="!chapter.audition && node.audition" @click="preview(chapter.id, node.id)">去体验<i class="iconfont icon-gengduo"></i></span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-bottom">
      <!-- <button class="button button-hollow">加入课程</button> -->
      <button class="button button-hollow" disabled v-if="!course.isCharge">本课程不支持自主加入</button>
      <button class="button button-hollow" :disabled="toTextbookType == 2" v-if="(course.isCharge && course.terms && course.terms.length == 0) || (course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 2)" @click="toTextbook">{{toTextbookMap[toTextbookType]}}</button>
      <button class="button button-hollow" disabled v-if="course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 1">本期未开始</button>
      <button class="button button-hollow" disabled v-if="course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 3">本期已结束</button>
    </div>
  </div>
  <van-overlay :show="classDialogVisiable">
    <div class="dialog-class">
      <div class="dialog-title">选择班级</div>
      <div class="label">请选择要加入的班级</div>
      <ul class="class-list">
        <li v-for="(item, index) in termForeignClassList" :key="index" :class="{'is-active': selectedForeignClass == item.classId}" @click="selectedForeignClass=item.classId">
          <div class="name">{{item.className}}</div>
          <div class="info">
            <span>教师：{{item.teacherNames.join('，')}}</span>
            <span>人数：{{item.studentCount || 0}}</span>
          </div>
        </li>
      </ul>
      <div class="btn-wrapper">
        <button class="button button-primary" @click="comfirmJoinForeignClass">确定</button>
        <button class="button button-text" @click="classDialogVisiable = false">取消</button>
      </div>
    </div>
  </van-overlay>
</um-page>
</template>
<script>
import { device } from '@/utils/device.js'
if (!device.isMobile) {
  location.href = location.href.replace('mobile.html', 'pc.html')
}
import { mapGetters } from 'vuex'
import HomeHeader from 'mobile/components/Page/homeHeader'
import { getTextbookInfo, getTextbookDetail, getTextbookOpen, getTermForeignSchool, joinTextbook, getTermOcId, getCourseMenu, foreignerJoinClass, getSecondarySiteInfo } from '@/api/courseApi'
import { UMOOC_COOKIE_DOMAIN } from '@/config'
import avatar from '@/mixins/avatar.js'
import fullpath from '@/mixins/fullpath.js'
import richtext from 'mobile/components/Richtext/richtext.vue'
import overflowHidden from 'mobile/components/overflowHidden/overflowHidden.vue'
import { formatDate, buildResourcePath } from '@/utils'
import cookies from '@/utils/cookie'
import { initWxShare, initQShare } from 'mobile/utils/share.js'
import { getHtmlText } from '@/utils'
import 'mediaelement'
import 'mediaelement/build/mediaelementplayer.min.css'
export default {
  name: 'page-course-home',
  mixins: [avatar, fullpath],
  data() {
    return {
      course: {},
      qrcode: null,
      tabIndex: 0,
      currentTermId: '',
      toTextbookMap: {
        '1': '进入课程',
        '2': '付费课程，请从电脑端购买',
        '3': '加入课程'
      },
      termTextbook: {},
      termForeignClassList: [],  // 允许外校学生加入的班级
      selectedForeignClass: '', //待加入的外校班级
      classDialogVisiable: false,
      headerMenuShow: false,
      isSwitch: ''
    };
  },
  computed: {
    ...mapGetters({user: 'user/user',  org: 'org/org'}),
    courseId () {
      return this.$route.params.id
    },
    logo () {
      //调用接口获取机构logo  
      if (!this.org.isMainSite) {
        return this.org.logo
      }
      return require('@/assets/images/logo.png')
    },
    toTextbookType () {
      if (this.user.userId) {
        if (this.course.isOpen == 1) {
          return 1 //'进入课程'
        }
        if (this.course.isOpen == -1) {
          if (this.course.charge) {
            return 2 //'购买课程'
          }
          return 3 //'加入课程'
        }
      } else {
        if (this.course.charge) {
            return 2 //'购买课程'
          }
        return 3 //'加入课程'
      }
    },
    currentTerm () {
      let reulst = {}
      if (this.currentTermId && this.course.terms.length > 0) {
        let arr = this.course.terms.filter(item => {
          return item.id == this.currentTermId
        })
        reulst = arr[0]
      }
      return reulst
    },
  },
  created () {
    window.test = this
    this.getOpen()
    // this.getTextbookInfo()
    this.isSwitch = cookies.get('isSwitch')
  },
  methods: {
    buildResourcePath,
    toHome () {
      let url = `https://www${UMOOC_COOKIE_DOMAIN}`
      if (!this.org.isMainSite) {
        url = `https://${this.org.prefix + UMOOC_COOKIE_DOMAIN}`
      }
      location.href = url
    },
    toggleHeaderMenu () {
      this.$refs.headerMenu.toggle();
    },
    haderMenuChange () {
      this.headerMenuShow = this.$refs.headerMenu.showPopup
    },
    getOpen() {
      if (this.user.userId) {
        return getTextbookOpen(this.courseId)
          .then(({result}) => {
            this.course.isOpen = result
            this.getTextbookInfo()
            // return result
          })
      } else {
        // return  { result: -1 }
        this.getTextbookInfo()
        this.course.isOpen = -1
      }
    },
    getTextbookInfo () {
      getTextbookInfo(this.courseId)
        .then(({result}) => {
          document.title = result.name
          result.isCharge = Number(result.isCharge)
          result.terms = result.terms || []
          result.terms = result.terms.reverse()
          this.course = {...this.course, ...result}
          if (result.terms && result.terms.length > 0) {
            result.terms.forEach((item, index) => {
              item.text = this.termTitle(item, index)
              item.value = item.id
            })
            this.currentTermId = result.terms[result.terms.length - 1].id
            this.termChange(result.terms[result.terms.length - 1].textbookId)
          } else {
            this.getTextbookDetail(this.courseId)
          }
          if (this.course.briefdesc) {
            this.$nextTick(() => {
              this.initVideo()
            })
          }
        })
    },
    getTextbookDetail (id) {
      getTextbookDetail(id)
        .then(({result}) => {
          this.termTextbook = result
          let options = {
            title: this.course.name, // 分享标题
            desc: getHtmlText(result.description), // 分享描述
            link: location.href, // 分享链接
            imgUrl: this.course.cover,
          }
          initQShare(options)
          initWxShare(options)
        })
    },
    initVideo () {
      this.player = new MediaElementPlayer('video-media', {
        videoWidth: document.getElementById('video-media').offsetWidth,
        videoHeight: document.getElementById('video-media').offsetHeight,
        success: (mediaElement) => {
        },
        error: (event) => {
          console.log(event.detail)
          setTimeout(()=> {
             event.detail.target.parentElement.nextElementSibling.getElementsByClassName('mejs__cannotplay')[0].getElementsByTagName('a')[0].setAttribute('href','javascript:;')
          },300)
         
        }
      })
    },
    termTitle (item, index) {
      return `第${index + 1}次开课 ${formatDate(item.startTime, 'yyyy/MM/dd')} - ${formatDate(item.endTime, 'yyyy/MM/dd')}`
    },
    getTermStatusText () {
      if (this.currentTerm.status == 1) {
        return `距离开课还有${this.currentTerm.daysToGo}天`
      } else if (this.currentTerm.status == 2) {
        return `开课中，本期选课人数：${this.currentTerm.studentNum}`
      } else if (this.currentTerm.status == 3) {
        return `本期选课人数：${this.currentTerm.studentNum}`
      }
    },
    dropdownChange (id) {
       let textbookId = this.course.terms.filter(item => item.id == id)[0].textbookId
       this.termChange(textbookId)
    },
    termChange (textbookId) {
      this.getTextbookDetail(textbookId)
    },
    tabChange (index) {
      this.tabIndex = index
    },
    preview (chapterId, nodeId) {
      let url = `https://ua${UMOOC_COOKIE_DOMAIN}/learnCourse/learnCourse.html?courseId=${this.currentTerm.textbookId || this.courseId}&chapterId=${chapterId}${nodeId? ('&sectionId=' + nodeId) :''}&isPreview=true&isAudition=true&notQRcode=true`
      // window.open(url)
      window.location.href = url
    },
    toTextbook () {
      if (this.toTextbookType == 3) {
        if (!this.user.userId) {
          this.toLogin()
        } else {
          if (this.user.role == 8) {
            this.$dialog.confirm({
              message: '当前登录的是教师帐号，请切换到学生模式再加入课程！',
              confirmButtonText: '切换到学生模式',
              messageAlign: 'left'
            })
            .then(() => {
              this.switchRole()
            })
          } else if (this.user.role == 9) {
            // 学生
            if (this.course.terms && this.course.terms.length > 0) {
              // 有学期
              if (this.user.orgId == this.course.orgId) {
                // 同校学生
                // Confirm({
                //   content: '本课程为同校教师开课，为避免成绩统计出现问题，请通过教师分享的班级编码或二维码加入。',
                //   confirmText: '我知道了',
                //   isShowCancel: false
                // })
                this.$dialog.alert({
                  message: '本课程为同校教师开课，为避免成绩统计出现问题，请通过教师分享的班级编码或二维码加入。',
                  confirmButtonText: '我知道了',
                  messageAlign: 'left'
                })
              } else {
                // 外校学生
                getTermForeignSchool({termId: this.currentTerm.id})
                  .then(({result}) => {
                    console.log(result)
                    if(result && result.length > 0) {
                      this.classDialogVisiable = true
                      this.termForeignClassList = result
                    } else {
                      // 无允许外校学生加入的班级  直接开通课件
                      this.joinTextbook()
                    }
                  })
              }
            } else {
              // 无学期 直接开通课件
              this.joinTextbook()
            }
            
          } else {
            this.otherRoleDialog = true
          }
        }
      } else if (this.toTextbookType == 1) {
        if (this.course.terms && this.course.terms.length > 0) {
          getTermOcId({ termId: this.currentTerm.id })
            .then(({result}) => {
              console.log(result)
              // result = 27162
              if (result) {
                this.toOcHomePage(result)
              } else {
                this.learnTextbook()
              }
            })
        } else {
          this.learnTextbook()
        }
      } else if (this.toTextbookType == 2) {
        if (!this.user.userId) {
          this.toLogin()
        } else {
          if (this.user.role == 8) {
            this.$dialog.confirm({
              message: '当前登录的是教师帐号，请切换到学生模式再加入课程！',
              confirmButtonText: '切换到学生模式',
              messageAlign: 'left'
            })
            .then(() => {
              this.switchRole()
            })
          } else if (this.user.role == 9) {
            window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning_web/web/product!immediatelyBuyCourse.do?productID=${this.courseId}`
          } else {
            // Confirm({
            //   content: '当前登录的不是学生帐号，请退出后使用学生帐号登录再购买！',
            //   confirmText: '退出登录',
            //   onConfirm: this.logout
            // })
            this.$dialog.confirm({
              message: '当前登录的不是学生帐号，请退出后使用学生帐号登录再购买！',
              confirmButtonText: '退出登录',
              messageAlign: 'left'
            })
            .then(() => {
              this.logout()
            })
          }
        }
      }
    },
    comfirmJoinForeignClass () {
      if (!this.selectedForeignClass) {
        return
      }
      foreignerJoinClass(this.selectedForeignClass)
        .then(({result}) => {
          this.classDialogVisiable = false
          this.course.isOpen = 1
          this.$dialog.confirm({
            message: '加入成功！是否立即进入课程学习？',
            confirmButtonText: '进入课程',
            messageAlign: 'left'
          })
          .then(() => {
            this.toOcHomePage(result)
          })
        })
    },
    joinTextbook () {
      joinTextbook(this.courseId)
        .then((result) => {
          console.log(result)
          // Confirm({
          //   content: '加入成功！是否立即进入课程学习？',
          //   confirmText: '进入课程',
          //   onConfirm: () => {
          //     this.learnTextbook()
          //   }
          // })
          this.$dialog.confirm({
            message: '加入成功！是否立即进入课程学习？',
            confirmButtonText: '进入课程',
            messageAlign: 'left'
          })
          .then(() => {
            this.learnTextbook()
          })
        })
    },
    learnTextbook () {
      window.location.href = `https://ua${UMOOC_COOKIE_DOMAIN}/learnCourse/learnCourse.html?courseId=${this.courseId}`
    },
    toOcHomePage (ocId) {
      getCourseMenu(ocId)
        .then(({result}) => {
          console.log(result)
          let hash = ''
          let menuId = 1
          let arr = result.filter(item => item.isHomepage)
          if (arr.length > 0) {
            menuId = arr[0].id
          }
          switch (menuId) {
            case 1:
              hash = 'announcement'
              break;
            case 2:
              hash = 'textbook'
              break;
            case 3:
              hash = 'resource'
              break;
            case 4:
              hash = 'homework'
              break;
            case 5:
              hash = 'discussion'
              break;
            case 6:
              hash = 'classroom'
              break;
            case 7:
              hash = 'live'
              break;
            case 8:
              hash = 'exam'
              break;
            default:
              hash = 'announcement'
          }
          let url = `https://courseweb${UMOOC_COOKIE_DOMAIN}/ulearning/index.html#/course/announcement?courseId=${ocId}`
          // window.open(url)
          window.location.href = url
        })
    },
    toMyHomePage () {
      switch (this.user.role) {
        case 182:
        case 183:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/admin`
          break;
        case 184:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/umooc/service/service.do?operation=toolKit`
          break;
        case 250:
          window.location.href = `https://ua${UMOOC_COOKIE_DOMAIN}/createCourse/#/main/courseList/editing`
          break;
        case 8:
        case 9:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning/index.html#/index/courseList`
          break;
        default:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning/index.html#/index/courseList`
      }
    },
    logout () {
      this.user.logout()
    },
    toLogin () {
      cookies.set('loginRedirectUrl', location.href)
      let url = `https://umooc${UMOOC_COOKIE_DOMAIN}/pc.html#/login`
      if (!this.org.isMainSite) {
        url = `https://${this.org.prefix + UMOOC_COOKIE_DOMAIN}/sld/pc.html#/login`
      }
      location.href = url
    },
    switchRole () {
      this.user.switchRole()
    },
    toMember () {
      this.$router.push({
        path: '/course/team/' + this.courseId
      })
    }
  },
  components: {
    richtext,
    overflowHidden,
    HomeHeader
  },
};
</script>
<style lang="scss" scoped>
.course-home-container{
  display: flex;
  height: 100%;
  flex-direction: column;
}
.home-body{
  flex: 1;
  height: 0;
  overflow: auto;
  .cover-wrapper{
    position: relative;
    padding-bottom: 56.25%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .video-wrapper{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  .tabs-wrapper{
    display: flex;
    justify-content: center;
    border-bottom: $--border-base;
     .tabs{
      display: flex;
      width: 100%;
      .tab-item{
        flex: 1;
        width: 0;
        text-align: center;
      }
      .tab{
        display: inline-block;
        padding: 8px 0;
        margin: 0 20px;
        line-height: 24px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
          color: $--color-primary;
        }
        &.is-active{
          border-bottom: solid 3px $--color-primary;
          color: $--color-primary;
        }
      }
    }
  }
  .course-info{
    padding: 20px 10px;
    border-bottom: solid 12px #f8f8f8;
    .title{
      margin-bottom: 8px;
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .info{
      display: flex;
      
      color: $--color-text-secondary;
      line-height: 24px;
      .school{
        flex: 1;
        margin-right: 10px;
      }
    }
    .van-dropdown-menu{
      margin-top: 12px;
      ::v-deep{
        .van-dropdown-menu__bar{
          height: 36px;
          background-color: #efeff7;
          border-radius: 4px;
          border-bottom: none;
        }
        .van-dropdown-menu__title{
          color: $--color-text-secondary;
          &::after{
            border-color: transparent transparent $--color-text-secondary $--color-text-secondary;
          }
        }
      }
    }
  }
  .tab-content{
    padding: 8px 0;
  }
  .course-section{
    padding: 12px 10px;
    .section-title{
      display: flex;
      justify-content: space-between;
      padding: 0 0 0 8px;
      margin: 4px 0 12px;
      font-size: 16px;
      line-height: 1;
      font-weight: bold;
      border-left: solid 3px $--color-primary;
      .detail-entry{
        font-size: 14px;
        font-weight: normal;
        i{
          font-size: 12px;
        }
      }
    }
  }
  .member-list{
    overflow-y: auto;
    white-space: nowrap;
    &::-webkit-scrollbar{
      display: none;
    }
    li{
      display: inline-block;
      width: 136px;
      padding: 20px 8px;
      margin-right: 12px;
      background-color: #f8f8f8;
      text-align: center;
      box-sizing: border-box;
      img{
        height: 66px;
        width: 66px;
        border-radius: 100%;
      }
      .name{
        margin-top: 12px;
        font-weight: bold;
        @include ellipsis;
      }
      .school{
        margin-top: 4px;
        font-size: 12px;
        line-height: 18px;
        color: $--color-text-secondary;
      }
    }
  }
  .textbook-wrapper{
    display: flex;
    img{
      width: 90px;
      height: 135px;
      margin-right: 12px;
    }
    .textbook-info{
      flex: 1;
      .title{
        height: 40px;
        margin-bottom: 8px;
        line-height: 20px;
        font-weight: bold;
        @include ellipsis2;
      }
      .info-item{
        padding: 4px 0;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
  .tab-index{
    padding: 20px 0;
    .chapter-list{
      .chapter-item{
        display: flex;
        align-items: center;
        padding: 8px 10px;
        background-color: #f8f8f8;
      }
      .chapter-title{
        flex: 1;
        margin-right: 8px;
        line-height: 20px;
        font-weight: bold;
      }
    }
    .node-list{
      margin-left: 10px;
      padding: 6px 0 18px 0;
      li{
        display: flex;
        align-items: center;
        padding: 6px 10px 6px 0;
        .dot{
          height: 4px;
          width: 4px;
          margin-right: 6px;
          border-radius: 100%;
          background-color: #ccc;
        }
        .node-title{
          flex: 1;
          width: 0;
          margin-right: 8px;
          line-height: 20px;
          // @include ellipsis;
        }        
      }
    }
    .audition{
      font-size: 12px;
      color: $--color-primary;
      i{
        font-size: 12px;
      }
    }
  }
}
.btn-bottom{
  padding: 20px;
}
.dialog-class{
  margin: 50px 20px;
  padding: 10px;
  background-color: #fff;
  .dialog-title{
    padding-bottom: 10px;
    font-weight: bold;
    font-size: 16px;
  }
  .label{
    margin-bottom: 10px;
  }
  .class-list{
    li{
      margin-bottom: 10px;
      padding: 6px 10px;
      border-radius: 2px;
      border: dashed 1px $--border-color-base;
      cursor: pointer;
      .info{
        line-height: 18px;
        font-size: 12px;
        color: $--color-text-secondary;
        span{
          margin-right: 20px;
        }
      }
      &.is-active{
        border: solid 1px $--color-primary;
        background-color: rgba(234,89,71,0.1);
        color: $--color-primary;
        .info{
          color: $--color-primary;
        }
      }
    }
  }
  .btn-wrapper{
    padding: 20px;
    text-align: center;
    .button{
      margin: 0 10px;
      width: auto;
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>